(function () {
  "use strict";
  if (window.gwpGalleryControls) { window.gwpGalleryControls.init(document); return; }
  var instances = new Map();
  function init(root) {
    root.querySelectorAll('[data-gwp-gallery-controls]').forEach(function (controls) {
      if (instances.has(controls)) return;
      var gallery = document.getElementById(controls.dataset.gwpGalleryControls);
      if (!gallery) return;
      var slides = Array.from(gallery.querySelectorAll('.gwp-gallery-item'));
      if (slides.length < 2) return;
      var host = controls.parentElement;
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      var enabled = controls.dataset.autoplay === 'true' && !motion.matches;
      var hovered = false, touching = false, focused = false, visible = false;
      var timer = null, scrollTimer = null;
      var toggle = controls.querySelector('[data-gallery-toggle]');
      var count = controls.querySelector('[data-gallery-count]');
      var cleanup = [];
      function on(target, event, callback, options) {
        target.addEventListener(event, callback, options);
        cleanup.push(function () { target.removeEventListener(event, callback, options); });
      }
      function index() {
        var origin = gallery.getBoundingClientRect().left;
        var distances = slides.map(function (slide) { return Math.abs(slide.getBoundingClientRect().left - origin); });
        return distances.indexOf(Math.min.apply(null, distances));
      }
      function stop() { clearTimeout(timer); timer = null; }
      function schedule() {
        stop();
        if (!enabled || !visible || document.hidden || hovered || touching || focused) return;
        timer = setTimeout(function () { move(1); }, 4000);
      }
      function update() {
        count.textContent = (index() + 1) + ' / ' + slides.length;
        if (toggle) {
          toggle.setAttribute('aria-label', enabled ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
          toggle.firstElementChild.textContent = enabled ? 'Ⅱ' : '▶';
        }
      }
      function move(delta) {
        var next = (index() + delta + slides.length) % slides.length;
        var img = slides[next].querySelector('img');
        if (img) img.loading = 'eager';
        var left = gallery.scrollLeft + slides[next].getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        gallery.scrollTo({ left: left, behavior: motion.matches ? 'instant' : 'smooth' });
        schedule();
      }
      on(controls.querySelector('[data-gallery-prev]'), 'click', function () { move(-1); });
      on(controls.querySelector('[data-gallery-next]'), 'click', function () { move(1); });
      if (toggle) on(toggle, 'click', function () { enabled = !enabled; update(); schedule(); });
      on(gallery, 'scroll', function () {
        stop(); clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { update(); schedule(); }, 180);
      }, { passive: true });
      on(host, 'pointerenter', function (event) { if (event.pointerType === 'mouse' && fine.matches) { hovered = true; stop(); } });
      on(host, 'pointerleave', function () { hovered = false; schedule(); });
      on(gallery, 'touchstart', function () { touching = true; stop(); }, { passive: true });
      on(window, 'touchend', function () { if (touching) { touching = false; schedule(); } }, { passive: true });
      on(window, 'touchcancel', function () { touching = false; schedule(); }, { passive: true });
      on(host, 'focusin', function (event) { focused = event.target.matches(':focus-visible'); if (focused) stop(); });
      on(host, 'focusout', function (event) { if (!host.contains(event.relatedTarget)) { focused = false; schedule(); } });
      on(host, 'keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); focused = true; move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      on(document, 'visibilitychange', function () { if (!document.hidden) { touching = false; hovered = false; } schedule(); });
      on(window, 'pageshow', function () { touching = false; hovered = false; update(); schedule(); });
      on(window, 'pagehide', stop);
      on(window, 'resize', function () { update(); schedule(); });
      on(motion, 'change', function () { if (motion.matches) enabled = false; update(); schedule(); });
      var observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.15 });
      observer.observe(gallery);
      controls.hidden = false;
      update();
      instances.set(controls, function () { stop(); clearTimeout(scrollTimer); observer.disconnect(); cleanup.forEach(function (remove) { remove(); }); instances.delete(controls); });
    });
  }
  window.gwpGalleryControls = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (dispose, controls) { if (event.target.contains(controls)) dispose(); }); });
})();
